import React from 'react';
import { useLocation } from 'react-router-dom';

export const useQueryParams = () => {
  const location = useLocation();
  const [queryParams, setQueryParams] = React.useState(new URLSearchParams(location.search));
  React.useEffect(() => {
    setQueryParams(new URLSearchParams(location.search));
  }, [location.search]);
  return queryParams;
};
